import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Search, Filter, MoreHorizontal, FileText, CheckCircle2, Clock } from 'lucide-react';
export function Assessments() {
  const [activeTab, setActiveTab] = useState('active');
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-579" data-mp="jkum8bo4yb5l">
      <div className="flex justify-between items-center" data-id="element-580" data-mp="oeyvx2oscxad">
        <div data-id="element-581" data-mp="td0cngyqokio">
          <h1 className="text-2xl font-semibold text-slate-900" data-id="element-582" data-mp="tda83k2jzjvr">Assessments</h1>
          <p className="text-slate-500 mt-1" data-id="element-583" data-mp="ybbqs3w2hh6p">
            Board and executive assessment cycles.
          </p>
        </div>
        <Link to="/app/assessments/new" className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors flex items-center" data-id="element-584" data-mp="12e8cw4ktfvfe">
          <Plus className="h-4 w-4 mr-2" data-id="element-585" data-mp="345lbkbw6x730" />
          New Cycle
        </Link>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-200 pb-4" data-id="element-586" data-mp="392tpg0ab2oyg">
        <div className="flex space-x-6" data-id="element-587" data-mp="yz98tr1vnq4v">
          <button onClick={() => setActiveTab('active')} className={`text-sm font-medium pb-4 -mb-4 border-b-2 transition-colors ${activeTab === 'active' ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-588" data-mp="u7r9f7fi5xm0">
            Active Cycles
          </button>
          <button onClick={() => setActiveTab('drafts')} className={`text-sm font-medium pb-4 -mb-4 border-b-2 transition-colors ${activeTab === 'drafts' ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-589" data-mp="1hxlmnq3qho6s">
            Drafts
          </button>
          <button onClick={() => setActiveTab('completed')} className={`text-sm font-medium pb-4 -mb-4 border-b-2 transition-colors ${activeTab === 'completed' ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-590" data-mp="13x11woe9dian">
            Completed
          </button>
        </div>

        <div className="flex items-center space-x-3" data-id="element-591" data-mp="3v3rzeeji4q11">
          <div className="relative" data-id="element-592" data-mp="3v3i9eqygiivc">
            <Search className="absolute left-3 top-2 h-4 w-4 text-slate-400" data-id="element-593" data-mp="3h48zua4ran0c" />
            <input type="text" placeholder="Search..." className="pl-9 pr-3 py-1.5 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-slate-200 w-48" data-id="element-594" data-mp="3h6d7n35s065w" />
          </div>
          <button className="p-1.5 border border-slate-200 rounded-md text-slate-500 hover:bg-slate-50" data-id="element-595" data-mp="3c67ipuqw4xri">
            <Filter className="h-4 w-4" data-id="element-596" data-mp="2yf2fkiobdncf" />
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-597" data-mp="32g5soxez959y">
        <table className="w-full text-left border-collapse" data-id="element-598" data-mp="2ogwe226f6j83">
          <thead data-id="element-599" data-mp="2teeqw3nk5ild">
            <tr className="bg-slate-50 border-b border-slate-200 text-xs uppercase tracking-wider text-slate-500 font-medium" data-id="element-600" data-mp="2texz2sneosm7">
              <th className="p-4" data-id="element-601" data-mp="29tehjr30guwr">Name</th>
              <th className="p-4" data-id="element-602" data-mp="24u1lqgu5wdi1">Status</th>
              <th className="p-4" data-id="element-603" data-mp="24v37pgcpukej">Progress</th>
              <th className="p-4" data-id="element-604" data-mp="2jr2gyubkaql9">Due Date</th>
              <th className="p-4 text-right" data-id="element-605" data-mp="2jru0h6rvwxv6">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 text-sm" data-id="element-606" data-mp="2eqxwkt7j9bpr">
            <tr className="hover:bg-slate-50 transition-colors" data-id="element-607" data-mp="2srqqpctxa4sc">
              <td className="p-4" data-id="element-608" data-mp="2spxny8mfk4pm">
                <div className="flex items-center" data-id="element-609" data-mp="2nsxdzmmgmht8">
                  <FileText className="h-5 w-5 text-slate-400 mr-3" data-id="element-610" data-mp="2ns4f17tqswln" />
                  <div data-id="element-611" data-mp="32htnlo4602vy">
                    <div className="font-medium text-slate-900" data-id="element-612" data-mp="32h0nv73midnb">
                      2026 Executive Effectiveness Review
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-613" data-mp="3bhyr3n68mh4u">
                      360° • 6 executive roles • 48 questions each
                    </div>
                  </div>
                </div>
              </td>
              <td className="p-4" data-id="element-614" data-mp="14ureeg619nv8">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800" data-id="element-615" data-mp="14tg8a9p4840y">
                  <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-1.5" data-id="element-616" data-mp="1ejswqd01whcd"></span>
                  Active
                </span>
              </td>
              <td className="p-4" data-id="element-617" data-mp="1jichwb6tlp3o">
                <div className="flex items-center space-x-2" data-id="element-618" data-mp="lv3pdw8ejfs6">
                  <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-619" data-mp="lwokbmymp0qk">
                    <div className="bg-slate-900 h-full w-[65%]" data-id="element-620" data-mp="quzvc10nthad"></div>
                  </div>
                  <span className="text-xs text-slate-500" data-id="element-621" data-mp="vsi51tmi40jf">65%</span>
                </div>
              </td>
              <td className="p-4 text-slate-600" data-id="element-622" data-mp="zvobp2diztqf">Nov 15, 2026</td>
              <td className="p-4 text-right" data-id="element-623" data-mp="278zrd0wdwmsc">
                <button className="text-slate-400 hover:text-slate-600" data-id="element-624" data-mp="2786tyqjbf9mv">
                  <MoreHorizontal className="h-5 w-5" data-id="element-625" data-mp="2b90ct5hwhy8w" />
                </button>
              </td>
            </tr>

            <tr className="hover:bg-slate-50 transition-colors" data-id="element-626" data-mp="3vrkrf177mnno">
              <td className="p-4" data-id="element-627" data-mp="3rq8wcg5kha83">
                <div className="flex items-center" data-id="element-628" data-mp="3rr0r5orcb3xb">
                  <FileText className="h-5 w-5 text-slate-400 mr-3" data-id="element-629" data-mp="3mz8ztc0d0u64" />
                  <div data-id="element-630" data-mp="3mxftxyxkmdz6">
                    <div className="font-medium text-slate-900" data-id="element-631" data-mp="3i17iowmhv4xa">
                      2026 Board Effectiveness Review
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-632" data-mp="3d35zmbp2j5lt">
                      Self-Assessment • 6 board roles • 48 questions each
                    </div>
                  </div>
                </div>
              </td>
              <td className="p-4" data-id="element-633" data-mp="342rd590dbkgq">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800" data-id="element-634" data-mp="2z2d17fvnbqdf">
                  <span className="w-1.5 h-1.5 bg-amber-500 rounded-full mr-1.5" data-id="element-635" data-mp="1291jnny503yn"></span>
                  Nominations
                </span>
              </td>
              <td className="p-4" data-id="element-636" data-mp="1gejzj0dcy15h">
                <div className="flex items-center space-x-2" data-id="element-637" data-mp="1gdimiqcs74l4">
                  <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-638" data-mp="1l6bstinwekzb">
                    <div className="bg-slate-900 h-full w-[15%]" data-id="element-639" data-mp="17enf5ay03og8"></div>
                  </div>
                  <span className="text-xs text-slate-500" data-id="element-640" data-mp="1cdhzwifj3n2z">15%</span>
                </div>
              </td>
              <td className="p-4 text-slate-600" data-id="element-641" data-mp="203caetcdkzk2">Nov 30, 2026</td>
              <td className="p-4 text-right" data-id="element-642" data-mp="200ydsg21rfae">
                <button className="text-slate-400 hover:text-slate-600" data-id="element-643" data-mp="244xsct3ro414">
                  <MoreHorizontal className="h-5 w-5" data-id="element-644" data-mp="1q4vedhykxur5" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}